import styled from 'styled-components';
import { colors } from 'app/variables';
import { media } from 'app/utils/style';

export const Container = styled.div`
  display: flex;
  padding-top: 1rem;
  color: ${colors.dustyGray};

  display: none;
  ${media.mediumHigh`
    display: block;
  `}
`;
export const Block = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  flex-direction: column-reverse;
  ${media.mediumDesktop`
    flex-direction: unset;
  `}
`;
